import moment from 'moment';
import React from 'react';
import './SignatureElement.scss';

const ApproveFourElement = (props) => {
  return (
    <div className="signature-element reviewed">
      <div className="signed">
        <div className="signed-text">Approved</div>
      </div>
      <div>
        <b>{props.approvedFourBy}</b> {moment(props.approvedFourAt).format('HH:mm on MMM D, YYYY')}
        {props.approveCommentFour && <div><b>Notes:</b> {props.approveCommentFour}</div>}
      </div>
    </div>
  );
};

export default ApproveFourElement;
